import React, { useContext, useEffect, useRef, useState } from 'react';
import Table, { TableHeader } from '../../../Table';
import Page from '../..';
import { setFilterColumn } from '../../../../store/utils';
import Form from '../../../Form';
import SVG from '../../../SVG';
import { ExportContext } from '../../../../provider/ExportProvider';
import { useAbility } from '../../../Hooks/useAbility';

export default function PageExportsLogistic() {
  const {
    logistics,
    checkLogisticIds,
    reportLogistic,
    allLogisticChecks,
    logisticCheckAll,
    checkLogisticId,
    deleteLogisticLoadings,
    editLogistic,
    logisticSearchFilter,
    setLogisticSearchFilter,
    getLogisticFilterField,
    getLogisticSortField,
    setLogisticSortField,
    getLogisticAutocompleteItems,
    setLogisticAutocompleteItems,
    setLogisticField,
    onLogisticLineClickHandler,
    onLogisticOriginLineClickHandler,
    filterLogistic,
    filterLogisticOrigin,
    setInvoice,
    LogisticTableControl,
    LogisticOriginTableControl,
    setModal,
    allLogisticOriginChecks,
    logisticOriginCheckAll,
    getLogisticOriginSortField,
    setLogisticOriginSortField,
    getLogisticOriginFilterField,
    setLogisticOriginField,
    getLogisticOriginAutocompleteItems,
    setLogisticOriginAutocompleteItems,
    setLogisticOriginSearchFilter,
    logisticOriginSearchFilter,
    reportLogisticOrigin,
    logisticOrigins,
    checkLogisticOriginIds,
    checkLogisticOriginId,
    editLogisticOrigin,
    deleteLogisticOriginLoadings,
    tableWidth,
    setTableWidth,
    filterGroupLogistic,
    user,
    selectedGroupId,
  } = useContext(ExportContext)!.controllers.logistic;
  const { Can, ability } = useAbility();
  const canDeleteLogistic = ability?.can('delete', 'Logistic');
  const canUpdateLogistic = ability?.can('update', 'Logistic');
  const canUpdateOrDeleteLogistic = canDeleteLogistic || canUpdateLogistic;
  const canUpdateAndDeleteLogistic = canDeleteLogistic && canUpdateLogistic;

  const logisticItems = logistics.map((logistic, index) => ({
    $isSelected: checkLogisticIds.includes(logistic.id),
    check: () => (
      <Form.Input.Checkbox
        checked={checkLogisticIds.includes(logistic.id)}
        onChange={() => checkLogisticId(logistic.id)}
      />
    ),
    ...logistic,
    ...(() =>
      canUpdateOrDeleteLogistic
        ? {
          control: () => (
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: '10px',
              }}
            >
              <Can I="update" a="Logistic">
                {() => (
                  <label
                    style={{
                      display: 'flex',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                  >
                    {true ? (
                      <SVG.Icon.Edit
                        onClick={() => {
                          editLogistic(logistic);
                        }}
                        width={25}
                        height={25}
                      />
                    ) : (
                      <SVG.Icon.Loader width={25} height={25} />
                    )}
                  </label>
                )}
              </Can>
              <Can I="delete" a="Logistic">
                {() => (
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    {!deleteLogisticLoadings[index] ? (
                      <SVG.Icon.Trash
                        style={{ padding: '0 2.5px' }}
                        onClick={() => {
                          setModal('single.deleteLogistics', true);
                          setInvoice('selected.logistic', logistic.id);
                        }}
                        width={20}
                        height={20}
                      />
                    ) : (
                      <SVG.Icon.Loader width={25} height={25} />
                    )}
                  </label>
                )}
              </Can>
            </label>
          ),
        }
        : {})(),
  }));

  const logisticHeaders: TableHeader[] = [
    {
      text: (
        <Form.Input.Checkbox checked={allLogisticChecks} onChange={logisticCheckAll} />
      ),
      value: 'check',
      width: 'auto',
      isFixed: true,
    },
    {
      text: 'Companhia',
      value: 'company.name',
      width: '170px',
      sort: {
        value: getLogisticSortField('company'),
        onChange: setLogisticSortField('company'),
      },
      filter: {
        value: getLogisticFilterField('company'),
        onChange: setLogisticField('company'),
        items: getLogisticAutocompleteItems('company'),
        handleItems: () => setLogisticAutocompleteItems('company'),
        label: 'Companhia',
      },
      onClear: () => {
        setLogisticSearchFilter(setFilterColumn('company', '', logisticSearchFilter));
        setInvoice(`autocompletes.logistics.company.filter.value`, '');
      },
    },
    {
      text: 'Nota NRC',
      value: 'nrcInvoiceNumber',
      width: '170px',
      sort: {
        value: getLogisticSortField('nrcInvoiceNumber'),
        onChange: setLogisticSortField('nrcInvoiceNumber'),
      },
      filter: {
        value: getLogisticFilterField('nrcInvoiceNumber'),
        onChange: setLogisticField('nrcInvoiceNumber'),
        items: getLogisticAutocompleteItems('nrcInvoiceNumber'),
        handleItems: () => setLogisticAutocompleteItems('nrcInvoiceNumber'),
        label: 'Nota NRC',
      },
      onClear: () => {
        setLogisticSearchFilter(setFilterColumn('nrcInvoiceNumber', '', logisticSearchFilter));
        setInvoice(`autocompletes.logistics.nrcInvoiceNumber.filter.value`, '');
      },
    },
    {
      text: 'Nota Cliente',
      value: 'clientInvoiceNumber',
      width: '170px',
      sort: {
        value: getLogisticSortField('clientInvoiceNumber'),
        onChange: setLogisticSortField('clientInvoiceNumber'),
      },
      filter: {
        value: getLogisticFilterField('clientInvoiceNumber'),
        onChange: setLogisticField('clientInvoiceNumber'),
        items: getLogisticAutocompleteItems('clientInvoiceNumber'),
        handleItems: () => setLogisticAutocompleteItems('clientInvoiceNumber'),
        label: 'Nota',
      },
      onClear: () => {
        setLogisticSearchFilter(setFilterColumn('clientInvoiceNumber', '', logisticSearchFilter));
        setInvoice(`autocompletes.logistics.clientInvoiceNumber.filter.value`, '');
      },
    },
    {
      text: 'Quantidade Volume',
      value: 'quantityVolume',
      width: '140px',
      sort: {
        value: getLogisticSortField('quantityVolume'),
        onChange: setLogisticSortField('quantityVolume'),
      },
      total: reportLogistic.quantityVolume,
    },
    {
      text: 'CRT',
      value: 'crt',
      width: '170px',
      sort: {
        value: getLogisticSortField('crt'),
        onChange: setLogisticSortField('crt'),
      },
      filter: {
        value: getLogisticFilterField('crt'),
        onChange: setLogisticField('crt'),
        items: getLogisticAutocompleteItems('crt'),
        handleItems: () => setLogisticAutocompleteItems('crt'),
        label: 'CRT',
      },
      onClear: () => {
        setLogisticSearchFilter(setFilterColumn('crt', '', logisticSearchFilter));
        setInvoice(`autocompletes.logistics.crt.filter.value`, '');
      },
    },
    {
      text: 'Cliente',
      value: 'clientName',
      width: '170px',
      sort: {
        value: getLogisticSortField('clientName'),
        onChange: setLogisticSortField('clientName'),
      },
      filter: {
        value: getLogisticFilterField('clientName'),
        onChange: setLogisticField('clientName'),
        items: getLogisticAutocompleteItems('clientName'),
        handleItems: () => setLogisticAutocompleteItems('clientName'),
        label: 'Cliente',
      },
      onClear: () => {
        setLogisticSearchFilter(setFilterColumn('clientName', '', logisticSearchFilter));
        setInvoice(`autocompletes.logistics.clientName.filter.value`, '');
      },
    },
    {
      text: 'Data Lançamento',
      value: 'releaseDate',
      width: '170px',
      mask: ({ releaseDate }) => releaseDate ? new Date(releaseDate).toLocaleString('pt-BR').split(',')[0] : "",
      sort: {
        value: getLogisticSortField('releaseDate'),
        onChange: setLogisticSortField('releaseDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('releaseDate', 'GEQ'),
          onChange: setLogisticField('releaseDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('releaseDate', 'LT'),
          onChange: setLogisticField('releaseDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('releaseDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('releaseDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    {
      text: 'Entreposto / Despacho',
      value: 'warehouseDispatchDate',
      width: '170px',
      color: () => 'white',
      mask: ({ warehouseDispatchDate }) => warehouseDispatchDate ? new Date(warehouseDispatchDate).toLocaleString('pt-BR').split(',')[0] : "",
      style: {
        justifyContent: 'center',
        fontWeight: 'bold',
      },
      background: ({ warehouseDispatchDate }) => warehouseDispatchDate ? '#02a34b' : '#FF0050',
      sort: {
        value: getLogisticSortField('warehouseDispatchDate'),
        onChange: setLogisticSortField('warehouseDispatchDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('warehouseDispatchDate', 'GEQ'),
          onChange: setLogisticField('warehouseDispatchDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('warehouseDispatchDate', 'LT'),
          onChange: setLogisticField('warehouseDispatchDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('warehouseDispatchDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('warehouseDispatchDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    {
      text: 'Receita',
      value: 'revenueDate',
      width: '170px',
      color: () => 'white',
      mask: ({ revenueDate }) => revenueDate ? new Date(revenueDate).toLocaleString('pt-BR').split(',')[0] : "",
      style: {
        justifyContent: 'center',
        fontWeight: 'bold',
      },
      background: ({ revenueDate }) => revenueDate ? '#02a34b' : '#FF0050',
      sort: {
        value: getLogisticSortField('revenueDate'),
        onChange: setLogisticSortField('revenueDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('revenueDate', 'GEQ'),
          onChange: setLogisticField('revenueDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('revenueDate', 'LT'),
          onChange: setLogisticField('revenueDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('revenueDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('revenueDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    {
      text: 'Aduana',
      value: 'customsDate',
      width: '170px',
      color: () => 'white',
      mask: ({ customsDate }) => customsDate ? new Date(customsDate).toLocaleString('pt-BR').split(',')[0] : "",
      style: {
        justifyContent: 'center',
        fontWeight: 'bold',
      },
      background: ({ customsDate }) => customsDate ? '#02a34b' : '#FF0050',
      sort: {
        value: getLogisticSortField('customsDate'),
        onChange: setLogisticSortField('customsDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('customsDate', 'GEQ'),
          onChange: setLogisticField('customsDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('customsDate', 'LT'),
          onChange: setLogisticField('customsDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('customsDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('customsDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    {
      text: 'Armazenadora',
      value: 'storageDate',
      width: '170px',
      color: () => 'white',
      mask: ({ storageDate }) => storageDate ? new Date(storageDate).toLocaleString('pt-BR').split(',')[0] : "",
      style: {
        justifyContent: 'center',
        fontWeight: 'bold',
      },
      background: ({ storageDate }) => storageDate ? '#02a34b' : '#FF0050',
      sort: {
        value: getLogisticSortField('storageDate'),
        onChange: setLogisticSortField('storageDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('storageDate', 'GEQ'),
          onChange: setLogisticField('storageDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('storageDate', 'LT'),
          onChange: setLogisticField('storageDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('storageDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('storageDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    {
      text: 'Cliente',
      value: 'clientDate',
      width: '170px',
      color: () => 'white',
      mask: ({ clientDate }) => clientDate ? new Date(clientDate).toLocaleString('pt-BR').split(',')[0] : "",
      background: ({ clientDate }) => clientDate ? '#02a34b' : '#FF0050',
      style: {
        justifyContent: 'center',
        fontWeight: 'bold',
      },
      sort: {
        value: getLogisticSortField('clientDate'),
        onChange: setLogisticSortField('clientDate'),
      },
      interval: [
        {
          value: getLogisticFilterField('clientDate', 'GEQ'),
          onChange: setLogisticField('clientDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticFilterField('clientDate', 'LT'),
          onChange: setLogisticField('clientDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('clientDate', '', logisticSearchFilter, 'GEQ');
        filter = setFilterColumn('clientDate', '', filter, 'LT');
        setLogisticSearchFilter(filter);
      },
    },
    ...(() =>
      canUpdateOrDeleteLogistic
        ? [
          {
            text: '',
            value: 'control',
            width: canUpdateAndDeleteLogistic ? '80px' : '40px',
            style: {
              margin: 'auto 10px auto auto',
            },
            isFixed: true,
            fixedPosition: 'right' as any,
          },
        ]
        : [])(),
  ];

  const logisticOriginHeaders: TableHeader[] = [
    {
      text: (
        <Form.Input.Checkbox checked={allLogisticOriginChecks} onChange={logisticOriginCheckAll} />
      ),
      value: 'check',
      width: 'auto',
    },
    {
      text: 'Companhia',
      value: 'company.name',
      width: '1fr',
      sort: {
        value: getLogisticOriginSortField('company'),
        onChange: setLogisticOriginSortField('company'),
      },
      filter: {
        value: getLogisticOriginFilterField('company'),
        onChange: setLogisticOriginField('company'),
        items: getLogisticOriginAutocompleteItems('company'),
        handleItems: () => setLogisticOriginAutocompleteItems('company'),
        label: 'Companhia',
      },
      onClear: () => {
        setLogisticOriginSearchFilter(setFilterColumn('company', '', logisticOriginSearchFilter));
        setInvoice(`autocompletes.logisticOrigins.company.filter.value`, '');
      },
      tooltip: {
        translateX: 0.5,
      },
    },
    {
      text: 'Data Lançamento',
      value: 'releaseDate',
      width: '1fr',
      mask: ({ releaseDate }) => releaseDate ? new Date(releaseDate).toLocaleString('pt-BR').split(',')[0] : "",
      sort: {
        value: getLogisticOriginSortField('releaseDate'),
        onChange: setLogisticOriginSortField('releaseDate'),
      },
      interval: [
        {
          value: getLogisticOriginFilterField('releaseDate', 'GEQ'),
          onChange: setLogisticOriginField('releaseDate', 'GEQ'),
          label: 'Data inicial',
        },
        {
          value: getLogisticOriginFilterField('releaseDate', 'LT'),
          onChange: setLogisticOriginField('releaseDate', 'LT'),
          label: 'Data final',
        },
      ],
      tooltip: {
        translateX: 0.5,
      },
      onClear: () => {
        let filter = setFilterColumn('releaseDate', '', logisticOriginSearchFilter, 'GEQ');
        filter = setFilterColumn('releaseDate', '', filter, 'LT');
        setLogisticOriginSearchFilter(filter);
      },
    },
    {
      text: 'Nota Origem',
      value: 'originInvoiceNumber',
      width: '1fr',
      sort: {
        value: getLogisticOriginSortField('originInvoiceNumber'),
        onChange: setLogisticOriginSortField('originInvoiceNumber'),
      },
      filter: {
        value: getLogisticOriginFilterField('originInvoiceNumber'),
        onChange: setLogisticOriginField('originInvoiceNumber'),
        items: getLogisticOriginAutocompleteItems('originInvoiceNumber'),
        handleItems: () => setLogisticOriginAutocompleteItems('originInvoiceNumber'),
        label: 'Nota Origem',
      },
      onClear: () => {
        setLogisticOriginSearchFilter(setFilterColumn('originInvoiceNumber', '', logisticOriginSearchFilter));
        setInvoice(`autocompletes.logisticOrigins.originInvoiceNumber.filter.value`, '');
      },
      tooltip: {
        translateX: 0.5,
      },
    },
    {
      text: 'Quantidade Volume',
      value: 'quantityVolume',
      width: '1fr',
      sort: {
        value: getLogisticOriginSortField('quantityVolume'),
        onChange: setLogisticOriginSortField('quantityVolume'),
      },
      total: reportLogisticOrigin.quantityVolume,
    },
    ...(() =>
      canUpdateOrDeleteLogistic
        ? [
          {
            text: '',
            value: 'control',
            width: canUpdateAndDeleteLogistic ? '80px' : '40px',
            style: {
              margin: 'auto 10px auto auto',
            },
            isFixed: true,
            fixedPosition: 'right' as any,
          },
        ]
        : [])(),
  ];

  const logisticOriginItems = logisticOrigins.map((logisticOrigin, index) => ({
    $isSelected: checkLogisticOriginIds.includes(logisticOrigin.id),
    check: () => (
      <Form.Input.Checkbox
        checked={checkLogisticOriginIds.includes(logisticOrigin.id)}
        onChange={() => checkLogisticOriginId(logisticOrigin.id)}
      />
    ),
    ...logisticOrigin,
    ...(() =>
      canUpdateOrDeleteLogistic
        ? {
          control: () => (
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                columnGap: '10px',
              }}
            >
              <Can I="update" a="Logistic">
                {() => (
                  <label
                    style={{
                      display: 'flex',
                      cursor: 'pointer',
                      alignItems: 'center',
                    }}
                  >
                    {true ? (
                      <SVG.Icon.Edit
                        onClick={() => {
                          editLogisticOrigin(logisticOrigin);
                        }}
                        width={25}
                        height={25}
                      />
                    ) : (
                      <SVG.Icon.Loader width={25} height={25} />
                    )}
                  </label>
                )}
              </Can>
              <Can I="delete" a="Logistic">
                {() => (
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    {!deleteLogisticOriginLoadings[index] ? (
                      <SVG.Icon.Trash
                        style={{ padding: '0 2.5px' }}
                        onClick={() => {
                          setModal('single.deleteLogisticOrigins', true);
                          setInvoice('selected.logisticOrigin', logisticOrigin.id);
                        }}
                        width={20}
                        height={20}
                      />
                    ) : (
                      <SVG.Icon.Loader width={25} height={25} />
                    )}
                  </label>
                )}
              </Can>
            </label>
          ),
        }
        : {})(),
  }));

  React.useEffect(() => {
    filterLogistic();
    filterLogisticOrigin();
  }, []);

  React.useEffect(() => {
    if (!selectedGroupId)
      filterGroupLogistic();
  }, [user, selectedGroupId]);

  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const startResize = () => setIsResizing(true);
  const stopResize = () => setIsResizing(false);

  const onMouseMove = (e: MouseEvent) => {
    if (!isResizing || !containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const newWidth = containerRect.right - e.clientX - 20;

    setTableWidth(Math.max(Math.min(newWidth, containerRect.width - 200), 200));
  };

  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', stopResize);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', stopResize);
    };
  }, [isResizing]);

  return (
    <Page className="page-banner">
      <div
        ref={containerRef}
        style={{
          display: 'flex',
          width: 'calc(100% - 22px)',
          gap: '10px',
          marginLeft: '16px',
          userSelect: isResizing ? 'none' : 'auto',
        }}
      >
        <div
          style={{
            position: 'relative',
            maxWidth: `calc(100% - ${tableWidth}px - 10px - 10px)`,
            minWidth: `calc(100% - ${tableWidth}px - 10px - 10px)`,
            minHeight: 'calc(100vh - 130px)',
            maxHeight: 'calc(100vh - 130px)',
            margin: '0',
            background: '#DDDDDD',
            borderRadius: '5px',
            overflow: 'hidden',
          }}
        >
          <Table
            headers={logisticHeaders}
            items={logisticItems}
            size="small"
            onLineClick={onLogisticLineClickHandler}
            containerStyle={{ height: 'calc(100vh - 210px)' }}
          >
            <LogisticTableControl />
          </Table>
          <div
            onMouseDown={startResize}
            style={{
              position: 'absolute',
              right: '-5px',
              top: 0,
              width: '10px',
              height: '100%',
              cursor: 'ew-resize',
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              zIndex: 10,
            }}
          />
        </div>

        <div
          style={{
            position: 'relative',
            maxWidth: `${tableWidth}px`,
            minWidth: `${tableWidth}px`,
            minHeight: 'calc(100vh - 130px)',
            maxHeight: 'calc(100vh - 130px)',
            margin: '0',
            background: '#DDDDDD',
            borderRadius: '5px',
            overflow: 'hidden',
          }}
        >
          <Table
            headers={logisticOriginHeaders}
            items={logisticOriginItems}
            size="small"
            onLineClick={onLogisticOriginLineClickHandler}
            containerStyle={{ height: 'calc(100vh - 210px)' }}
          >
            <LogisticOriginTableControl />
          </Table>
        </div>
      </div>
    </Page>
  );
}
